import React from 'react';

import { Modal } from 'react-bootstrap';

const ModalBody = (props: React.HTMLAttributes<HTMLDivElement>): JSX.Element => <Modal.Body {...props} />;

ModalBody.displayName = 'ModalBody';

export default ModalBody;
